exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download-link[data-v-d1ba569c]{margin-left:5px}", ""]);

// exports
